import { km } from '../../helpers/km';

type EventParams = {
  typeDirection: 'RT' | 'OW';
  route: string;
};
export const serpSearchStart = (params: EventParams): void =>
  km({ name: 'serp_search_start', params });
